import { Controller } from 'stimulus';
import Constants from '../classes/Constants';
import QuoteIcon from '../images/dividend/img-quote.svg';

class Quote extends Controller {
  static targets = [
    'quoteIcon',
    'text',
    'author',
    'authorTitle',
    'authorPicture'
  ]

  connect() {
    const numberOfQuotes = Constants.Quotes.length;
    const quote = Constants.Quotes[Math.floor(Math.random() * numberOfQuotes)];
    this.textTarget.textContent = quote.text;
    this.authorTarget.textContent = quote.author;
    this.quoteIconTarget.src = QuoteIcon;
    this.authorPictureTarget.src = quote.authorImage;
    this.authorTitleTarget.textContent = quote.authorTitle;
  }

}

export default Quote;
